export default __webpack_public_path__ + "static/catchup-image-tablet-494031e70608b2b6e8601dd68550f37a.svg";